module.exports = __webpack_public_path__ + "img/1L2.c9bf3bdf.png";